import cookies from 'js-cookie';

import cookieNames from '../constants/cookieNames';
import getExpFromToken from './getExpFromToken';

const fallbackTokenPayload = () => {
  const accessTokenCookie = cookies.get(cookieNames.accessToken);

  if (accessTokenCookie) {
    return {
      access: {
        token: accessTokenCookie,
        valid_until: getExpFromToken(accessTokenCookie),
      },
      refresh: {
        token: '',
      },
      country: cookies.get(cookieNames.localizationCountry) || '',
    };
  }

  return null;
};

export default fallbackTokenPayload;
